import { apiConfig } from "./apiConfig";

const YEARS_TO_FETCH = 18;

const toOtdDate = (year, month, day) => {
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  const yy = String(year % 100).padStart(2, "0");
  return `${mm}.${dd}.1${yy}`;
};

/** Parse MMDD (e.g. "0819") into { month, day } or null if invalid. */
export const parseThisDayParam = (dateParam) => {
  if (!dateParam) return null;
  const raw = String(dateParam).replace(/\D/g, "");
  if (raw.length !== 4) return null;
  const month = parseInt(raw.slice(0, 2), 10);
  const day = parseInt(raw.slice(2, 4), 10);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  // Reject impossible calendar dates (e.g. Feb 30) using a non-leap probe year
  const probe = new Date(2021, month - 1, day);
  if (probe.getMonth() !== month - 1 || probe.getDate() !== day) return null;
  return { month, day };
};

export const formatThisDayLabel = (month, day) =>
  new Date(2000, month - 1, day).toLocaleDateString("en-US", { month: "long", day: "numeric" });

export const getThisDayPosts = (axios, dateParam) => {
  const now = new Date();
  const parsed = parseThisDayParam(dateParam);
  const month = parsed ? parsed.month : now.getMonth() + 1;
  const day = parsed ? parsed.day : now.getDate();
  const currentYear = now.getFullYear();
  const years = [];

  for (let year = currentYear - 1; year >= currentYear - YEARS_TO_FETCH; year -= 1) {
    years.push(year);
  }

  return Promise.all(
    years.map((year) =>
      axios
        .get(`${apiConfig.oftheday.date}${toOtdDate(year, month, day)}`)
        .then((res) => (res && res.data && res.data.posts) || [])
        .catch(() => [])
    )
  ).then((yearPosts) => ({
    data: {
      posts: yearPosts.flat(),
      month,
      day,
    },
  }));
};
